import { makeObservable, override } from 'mobx';

import { store } from '@store';

import { AbstractField } from './AbstractField';

export class ComputedField extends AbstractField<string, string> {
    constructor(params: string, name: string) {
        super(params, name);
        makeObservable(this);
    }

    @override
    public get hasData(): boolean {
        return this.isChanged; // || !!this.fieldValue;
    }

    public makeUpdateParams(): string {
        return this.fieldValue;
    }

    protected get isChanged(): boolean {
        return store.entry.changedComputedFields.has(this.fieldName);
    }

    protected setFieldValue(value: string): void {
        this.fieldValue = value;
    }
}
